import { Browser } from "@capacitor/browser";

export function openExternalUrl(url: string): void {
  Browser.open({ url, windowName: "_system" });
}

export function openMailTo(email: string, subject?: string, body?: string): void {
  const link = document.createElement("a");

  let url: string = `mailto:${email}`;

  let separator = "?";

  if (body !== undefined) {
    url += `${separator}body=${encodeURIComponent(body)}`;
    separator = "&";
  }

  if (subject !== undefined) {
    url += `${separator}subject=${encodeURIComponent(subject)}`;
    separator = "&";
  }

  link.href = url;
  link.click();
}

export function openNativeMapsLocation(location: string): void {
  const link = document.createElement("a");

  const url: string = `maps://maps.google.com/?q=${encodeURIComponent(location)}`;

  link.href = url;
  link.click();
}

export function callNumber(phoneNumber: string): void {
  const link = document.createElement("a");
  link.href = "tel:" + phoneNumber;
  link.click();
}
